// Bulgarian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `отворено до ${date}` : ''),
    },
    interview: {
      title: 'Отговорете на видео интервюто',
      submit: 'Изпратете отговорите и завършете интервюто',
      continueLater: 'Продължете по-късно',
      startInterview: 'Започнете интервюто',
      duplicateError: 'Вече сте участвали в това интервю. Вече сте получили имейл от invitations@recright.com, който съдържа линк, който може да бъде използван за продължаване на интервюто.',
      confirmSubmitHeader: 'Не сте отговорили на всички въпроси от интервюто',
      confirmSubmitContent: 'Наистина ли искате да завършите интервюто?',
      confirmSubmitContentWarning: 'След това няма да можете да запишете отново своите отговори.',
      submitInterviewHeader: 'Изпратете отговорите си на интервюто',
      submitInterviewContent: 'Сигурни ли сте, че искате да изпратите интервюто си?',
      confirmSubmitButton: 'Изпратете отговорите и завършете интервюто',
      preview: 'Можете да прегледате видео въпросите тук.',
      requiredQuestionsNotAnswered: 'Моля, отговорете на всички задължителни въпроси, преди да изпратите.',

      withdrawLink: 'Вече не се интересувате от позицията? Оттеглете се от процеса тук.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },


    interviewForm: {
      name: 'Име',
      city: 'Роден град',
      email: 'Електронна поща',
      phone: 'Телефонен номер',
      link: 'Връзка',
      legendBasicInfo: 'Основна информация',
      placeholderName: 'Въведете името си',
      placeholderEmail: 'Въведете имейла си',
      placeholderPhone: 'Въведете телефона си',
      placeholderCity: 'Въведете настоящия си град',
      placeholderLink: 'Добавете линк, например към Вашия профил в LinkedIn.',
      legendAttachments: 'Приложения',
      legendAdditionalFields: 'Допълнителна информация',
      required: 'Елементите, отбелязани със * звездичка, са задължителни.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Аудио',
        video: 'Видео',
        yes: 'Да',
        no: 'Не',
        supported: 'Поддържани',
        quality: 'Качество',
        header: 'Тестване на устройството и на връзката с интернет',
        description: 'Сега ще направим тест, за да се уверим, че връзката Ви с интернет и необходимият хардуер за провеждане на интервюто (камера и телефон) работят правилно. Когато бъдете подканени, моля, разрешете на процеса на тестване да използва камерата и микрофона и се уверете, че камерата Ви не е закрита. Тестването ще отнема около 30 секунди. Препоръчваме Ви да говорите по време на тестването на хардуера.',
        inProgress: 'Тестването е в ход...',
        networkTestResults: 'Резултати от тестване на мрежата',
        qualityTestResults: 'Резултати от тестване на качеството',
        testPassedQuality: 'Тестването на качеството премина успешно',
        testFailedQuality: 'Тестът за качество е неуспешен',
        testPassedNetwork: 'Мрежовият тест е преминат',
        testFailedNetwork: 'Тестването на мрежата беше неуспешно',
        startTest: 'Започнете тестването',
        startInterview: 'Започнете интервюто',
        testAgain: 'Тествайте отново',
        confirmWarning: ' Когато Вашето видео интервю започне, автоматично ще можете да видите първия си въпрос от интервюто. След като видите въпроса, ще бъдете прехвърлени към етапа на подготовка.',
        confirmTitle: 'На път сте да започнете Вашето интервю',
        confirmText: 'Имате кратко време, за да се подготвите, преди да отговорите на всеки въпрос. След като се подготвите, имате предварително зададено време да отговорите на въпроса. Моля, отбележете, че можете да изпратите отговора си веднага, щом сте готов/а, дори преди да изтече предварително зададеното време за отговор.',
        confirmText2: 'След като изпратите Вашия отговор, преминете към следващия въпрос и така до изчерпване на въпросите.',
        confirmText3:
          'Моля, имайте предвид, че след като запишете отговора си на даден въпрос, ще имате 30 секунди, за да повторите отговора си, ако повторението е разрешено за въпроса. Ако не инициирате повторение на отговора в рамките на този 30-секунден период, текущият Ви отговор ще бъде изпратен автоматично и ще бъдете пренасочени към следващия въпрос.',
        goodLuck: 'Просто поемете дълбоко въздух и всичко ще бъде наред. Желаем Ви късмет!',
        qualityRating: {
          excellent: 'Отлично',
          good: 'Добре',
          fair: 'Задоволително',
          poor: 'Слабо представяне',
          bad: 'Много лошо представяне',
        },
      },
      questionAnswerView: {
        submitAndFinish: 'Изпрати и завърши интервюто',
        retake: 'Запиши отново',
        take: 'Запис',
        takesLeft: 'Останали записи',
        stop: 'Стоп',
        title: title => `Отговорете на въпросите от интервюто ${title}`,
        question: 'Въпрос',
        submitAndNext: 'Изпрати и премини напред',
        submitSuccess: 'Видеото е изпратено успешно!',
        skipText: 'Започни записване',
        skipTextQuestion: 'Готови ли сте? Продължете напред.',
        retakeConfirmTitle: 'Сигурни ли сте, че искате да повторите отговора си на този въпрос?',
        retakeConfirmSubmit: 'Да, започнете повторението',
        submitInfoForward: 'Автоматично изпращане на текущия отговор и преминаване напред в',
        submitInfoForward2: 'секунди',
        nonAnswerableText: 'Това съобщение не изисква отговор. След това съобщение ще бъдете препратени директно към следващия въпрос.',
        nonAnswerableVideo: 'Това видео не изисква отговор. След това видео ще бъдете препратени директно към следващия въпрос.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Имате ${answerMinutes} минути и ${answerSeconds} секунди, за да отговорите на въпроса.`,
      },
      publisher: {
        toNextQuestion: timer => `Преминаване към следващия въпрос след ${timer}`,
        recordingStarts: timer => `Записването започва след ${timer}`,
      },
      errors: {
        tooManyConnections: 'Тази връзка беше затворена, защото вече имате отворена връзка в друг раздел или прозорец.',
        unsupportedBrowser: 'За съжаление това действие не се поддържа от Вашия браузър. Моля, използвайте различен браузър.',
        networkError: 'Няма връзка с интернет.',
        reconnecting: 'Връзката беше прекъсната. Опит за повторно свързване.',
        generalError: 'Нещо се обърка. Моля, отново заредете страницата и опитайте пак.',
        allowMediaDevicesError: 'Това действие не успя да получи достъп до медийни устройства (камера или микрофон). Моля, уверете се, че сте разрешили на браузъра да използва Вашата камера и микрофон.',
        noAvailableDevicesError: 'Не можахме да намерим камера или микрофон.',
        initPublisherError: 'Операцията не успя поради грешка. Уверете се, че сте разрешили на браузъра да използва камерата и микрофона ви, както и че те не се използват от друго приложение, и опитайте отново.',
      },
      browserInfo: {
        browserSupportTitle: 'Поддръжка на браузър',
        supportedBrowsers: 'Това тестване и интервюто поддържат най-новите версии на Chrome, Firefox, Safari и Edge.',
        mobileSupported: 'Поддържани браузъри на мобилно устройство',
        android: 'Android: Google Chrome (най-новата версия), Firefox (най-новата версия)',
        iOS: 'iOS: Safari (най-новата версия)',
        latestVersion: 'Моля, уверете се, че използвате най-новата версия на браузъра. Това ще гарантира гладка и безпроблемна работа.',
        freezeInstruction: 'Ако видеозаписът не започне или екранът за запис остане черен, моля, опреснете страницата.',
        unsupportedOnIos: 'Изглежда, че използвате браузър, който не се поддържа от iOS. Моля, използвайте Safari.',
        ieUnsupported: 'Изглежда че използвате Internet Explorer. За съжаление Internet Explorer не се поддържа като браузър за това тестване или интервю. Моля, използвайте различен браузър.',
        qualityTestNotSupported: 'За съжаление тестването на хардуера не се поддържа от браузъра, който използвате. Може да продължите към интервюто, без да тествате аудио и видео качеството или като алтернатива, използвайте различен браузър.',
      },
      reconnectSuccess: 'Повторното свързване е успешно!',
      continue: 'Продължи',
    },

    withdraw: {
      title: 'Вече не се интересувате от позицията?',
      description: 'Оттеглете се от процеса за подбор на кадри.',
      buttonText: 'Оттегляне от процеса за подбор на кадри',
      thankYouTitle: 'Благодарим Ви!',
      thankYouText: 'Уведомихте експертите по подбор на персонал, че вече не се интересувате от позицията.',
      confirm: 'Наистина ли искате да се оттеглите от процеса за подбор на кадри? След оттеглянето Ви повече няма да можете да отговаряте на въпросите от това интервю или от всяко друго интервю, свързано с тази позиция.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Изпрати',
      continue: 'Продължи',
      supportCenter: 'Recright Help Center',
      thankYou:
        'Благодарим Ви за Вашия видео отговор! Ще се свържем с Вас скоро!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Благодарим Ви, че участвахте в интервюто!',
      reopenDescription: 'Ако сте затворили това интервю без да искате, не се тревожете! Можете да го отворите отново, като кликнете върху бутона по-долу!',
      reopenButtonText: 'Поднови интервюто',
      description1: 'Чудесно, отговорихте на всичките въпроси и отговорите са изпратени на получателя.',
      descriptionsupport: mailto => `Ако сте затворили интервюто случайно, моля, свържете се с отдела за обслужване на клиенти на ${mailto} и ние ще отворим интервюто отново.`,
      descriptionfeedback: 'Вашият опит е важен за нас! Как се чувствахте, докато отговаряхте на въпросите във видео интервюто? Как бихте подобрили нашата услуга? Оставете Вашето мнение тук.',
      feedbackbutton: 'Оставете Вашето мнение за нашата работа!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Лично съобщение',
    },

    closed: {
      title: 'Интервюто завърши или интервюто приключи',
      description: 'Видео интервюто, на което сте поканени приключи, или Вие вече сте изпратили Вашите отговори.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Вашето видео интервю сега е запаметено!',
      description: 'Ако желаете да продължите с видео интервюто, използвайте линка, изпратен на Вашия имейл. Видео отговорите, които вече са записани, ще бъдат налични, когато се върнете. Успех в търсенето на работа!',
      remember: 'Не забравяйте да изпратите отговорите на отговорника по набиране на персонал след като приключите с отговорите на въпросите в интервюто.',
      deleteHistory: 'Ако използвате обществен компютър, не забравяйте да изчистите историята на браузъра. По този начин Вашето интервю е защитено.',
    },
    unpublished: {
      title: 'Интервюто все още не е публикувано',
      publishTime: publishTime => `Интервюто ще бъде публикувано на ${publishTime}`,
    },
  },
}
